import React, { useEffect } from 'react';
import withRouter from '../Components/Common/withRouter';

//redux
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { useProfile } from 'Components/Hooks/UserHooks';
import { Navigate } from 'react-router-dom';

const NonAuthLayout = ({ children }: any) => {
    const nonauthData = createSelector(
        (state: any) => state?.Layout?.layoutModeType,
        (layoutModeType: any) => layoutModeType
    );
    // Inside your component
    const layoutModeType = useSelector(nonauthData);
    const { userProfile, loading, token } = useProfile();

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme")
        }
    }, [layoutModeType]);

    if (userProfile && token) {
        let pathName = "/manage-products";
        return (
          <React.Fragment>
            <Navigate to={pathName} />
          </React.Fragment>
        );
    }

    return (
        <>
            {children}
        </>
    );
};

export default withRouter(NonAuthLayout);